import { useGetCareProviderAdmissionsPage } from "apollo/hooks/queries";
import { QUERY_PROGRESS_PENDING } from "core/consts";
import { ValueOf } from "core/types";
import SpinnerPage, {
  SpinnerPageContainer,
} from "ds_legacy/components/Spinner";
import { useParams } from "react-router-dom";
import { AdmissionsFooter } from "../shared/AdmissionsFooter";
import { AdmissionsHeader } from "../shared/AdmissionsHeader";
import { StopAuction } from "./Screens/StopAuction";

// This sets the action screen based on the action param in the email link
export const ADMISSIONS_ACTION_SCREENS = {
  STOP_AUCTION: "stop",
} as const;

export type AdmissionsActionScreen = ValueOf<typeof ADMISSIONS_ACTION_SCREENS>;

const ACTION_SCREEN_COMPONENTS: Record<
  AdmissionsActionScreen,
  React.ComponentType
> = {
  [ADMISSIONS_ACTION_SCREENS.STOP_AUCTION]: StopAuction,
};

export default function AdmissionsActionScreens() {
  const { action, admissionsId } = useParams<{
    admissionsId: string;
    action: AdmissionsActionScreen;
  }>();
  const [queryProgress, admissionsPayload] = useGetCareProviderAdmissionsPage({
    admissionsId,
  });

  const ActionScreenComponent = action
    ? ACTION_SCREEN_COMPONENTS?.[action]
    : null;

  if (!ActionScreenComponent) {
    return null;
  }

  if (queryProgress === QUERY_PROGRESS_PENDING) {
    return (
      <SpinnerPageContainer>
        <SpinnerPage id="action-screen-loading" />
      </SpinnerPageContainer>
    );
  }

  return (
    <main className="flex min-h-screen flex-col">
      <AdmissionsHeader logo={admissionsPayload?.logo} />
      <ActionScreenComponent />
      <AdmissionsFooter
        privacyURL={admissionsPayload?.careprovider.profile?.privacy_url}
      />
    </main>
  );
}
